<template>
  <div id="app">
    <nav-bar></nav-bar>
    <div id="main-container">
      <fade-transition mode="out-in">
        <router-view/>
      </fade-transition>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import FadeTransition from '@/components/FadeTransition'
  import Footer from '@/components/Footer'

  export const chartVisiblity = true
  export default {
    name: 'App',
    components: {
      NavBar,
      Footer,
      FadeTransition
    }
  }
</script>

<style>
  :root {
    --cold_silver: #f3f5fc;
    --golden_light: rgba(253,223,174,0.4);
    --white_layer: rgba(255,255,255,0.4);
    --golden: #d79600;
    --golden_hover: #fb9a08;
    --blue_background: #9ab0ff;
    --blue_blue: #234ab1;
    --light_blue: #99bbf2;
  }
  html {
    height: 100%;
  }
  body {
    background-image: url('assets/images/pattern.png');
    height: 100%;
    margin: 0;
    padding: 0;
  }
  #app {
    height:100%;
  }
  #main-container{
    height: calc(100% - 122px);
    /*overflow: paged-x;*/
    /*padding: 10px;*/
    background-color: var(--white_layer);
    display: flex;
    display: -webkit-flex; /* Safari */
    -webkit-flex-direction: row-reverse; /* Safari 6.1+ */
    flex-direction: row;
    justify-content: center;
    overflow: visible;
  }
  #component-container {
    height: 100%;
    width: 100% !important;
    overflow: auto;
  }
  li.page-item a {
    background-color: white;
    color: var(--golden);
    padding: 8px 6px;
  }

  li.page-item:hover a {
    background-color: var(--golden_light);
    color: var(--golden);
  }

  li.page-item.active a {
    background-color: var(--golden) !important;
    color: var(--golden_light);
    box-shadow: 0 0 0 var(--golden) !important;
    border: 1px solid var(--golden) !important;
  }

  li.page-item:active a {
    background-color: var(--golden);
    color: var(--golden_light);
    box-shadow: 0 0 0 var(--golden) !important;
    border: 1px solid var(--golden) !important;
  }

  li.page-item:focus a {
  }
  @media only screen and (min-width: 768px) {
    #component-container {
      height: 100%;
      width: 100% !important;
      overflow: inherit;
    }
  }

  th {
    font-size: 0.8rem;
  }
  .spinner-center {
    width: 3rem;
    height: 3rem;
    /*border: 9px solid;*/
    /*padding: 20px;*/

    position: absolute;
    top: 50%;
    left: 50%;

    margin: -1rem 0 0 -2rem;
    color: var(--golden);
  }
  .page-link, .page-link:visited, .page-link:hover, .page-link:active, .page-link:focus {
    outline: 0 none !important;
    border: 0;
  }
  :focus {
    outline: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue